// extracted by mini-css-extract-plugin
module.exports = {"secondaryLight":"#EDEDED","primaryBlack":"#000000","secondaryDeep":"#252525","secondary":"#B1B1B1","redDefault":"#D43B3B","white":"#FFFFFF"};